import { InputField } from "components/InputField/Input";
import { CommonButton } from "components/Buttons/Buttons";
import { BiMinus, BiPlus } from "react-icons/bi";

const useProductDataTable = (formik, setDeleteProductID, setShowDeleteProductModal) => {
    const addProductOnChange = (e, i, fieldName) => {
        formik.setFieldValue(`sale_items[${i}].${fieldName}`, e?.value || e?.target?.value);
    };


    const modalTableColumns = [
        {
            field: "stock_name",
            header: "Item",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="stock_name"
                        name="stock_name"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "stock_name")}
                        value={formik.values.sale_items[event.rowIndex]?.stock_name}
                        type="text"
                        width="full"
                        autoCompleteFieldName="stock_name"
                        required={true}
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.sale_items?.[event.rowIndex]?.stock_name}
                    />
                </div>
            ),
        },
        {
            field: "stock_uom",
            header: "UOM",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="stock_uom"
                        name="stock_uom"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "stock_uom")}
                        value={formik.values.sale_items[event.rowIndex]?.stock_uom}
                        type="text"
                        width="full"
                        autoCompleteFieldName="stock_uom"
                        required={true}
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.sale_items?.[event.rowIndex]?.stock_uom}
                    />
                </div>
            ),
        },
        {
            field: "rate",
            header: "Rate",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="rate"
                        name="rate"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "rate")}
                        value={formik.values.sale_items[event.rowIndex]?.rate}
                        type="numbers"
                        width="full"
                        autoCompleteFieldName="rate"
                        required={false}
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.sale_items?.[event.rowIndex]?.rate}
                    />
                </div>
            ),
        },
        {
            field: "quantity",
            header: "Quantity",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="quantity"
                        name="quantity"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "quantity")}
                        value={formik.values.sale_items[event.rowIndex]?.quantity}
                        type="numbers"
                        width="full"
                        autoCompleteFieldName="quantity"
                        required={false}
                        messagePosition='bottom'
                        errors={formik.errors.sale_items?.[event.rowIndex]?.quantity}
                    />
                </div>
            ),
        },
        {
            field: "total_price_per_item",
            header: "Total price",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="total_price_per_item"
                        name="total_price_per_item"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "total_price_per_item")}
                        value={formik.values.sale_items[event.rowIndex]?.total_price_per_item}
                        type="numbers"
                        width="full"
                        autoCompleteFieldName="total_price_per_item"
                        required={false}
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.sale_items?.[event.rowIndex]?.total_price_per_item}
                    />
                </div>
            ),
        },
    ]

    const deleteSaleItems = (rowData) => {
        const {id, invoice} = rowData;
        setDeleteProductID({id, invoice})
        setShowDeleteProductModal(true)
    }

    const modalTableActionButton = (rowData, {rowIndex}) => {
        const handleOnFieldIncrement = () => {
            const joinData = formik.values.sale_items.concat({
                fieldId: rowIndex + 1,
                stock_name: "",
                stock_uom: "",
                rate: "",
                quantity: "",
                total_price_per_item: "",
            });
            formik.setFieldValue("sale_items", joinData)
        };

        const handleOnFieldDecrement = (i) => {
            if(rowData.id > 0){
                return deleteSaleItems(rowData)
            }
            const removeData = [...formik.values.sale_items];
            removeData.splice(rowIndex, 1);
            formik.setFieldValue("sale_items", removeData);
        };

        return (
            <>
                <div className="flex items-center justify-center">
                    {
                        formik.values.sale_items.length - 1 === rowIndex ? (
                            <>
                                <CommonButton 
                                    icon={<BiPlus className="text-green-700 text-2xl" />}
                                    className="p-button-rounded p-mr-2 action-button-green"
                                    title=""
                                    type="button"
                                    onClick={handleOnFieldIncrement}
                                />
                                {formik.values.sale_items.length !== 1 && 
                                <CommonButton 
                                    icon={<BiMinus className="text-red-700 text-2xl" />} 
                                    className="p-button-rounded p-mr-2 action-button-red" 
                                    title="" 
                                    type="button" 
                                    onClick={handleOnFieldDecrement} 
                                />}
                            </>
                        ) : 
                        (
                            <>
                                <CommonButton 
                                    icon={<BiMinus className="text-red-700 text-2xl" />} 
                                    className="p-button-rounded p-mr-2 action-button-red" 
                                    title="" 
                                    type="button" 
                                    onClick={handleOnFieldDecrement} 
                                />
                            </>
                        )
                    }
                </div>
            </>
        )
    }

    return {
        modalTableColumns,
        modalTableActionButton,
    }
}

export default useProductDataTable